/**
 * Grade Utilities
 * Functions for converting marks/percentages to letter grades
 */

/**
 * Convert percentage to letter grade
 * Supports both standard and custom grading scales
 * @param percentage - Percentage score (0-100)
 * @param useCustomScale - If true, uses custom scale where A+ starts at 50%
 * @returns Letter grade (A+, A, B+, B, C+, C, D, F)
 */
export function percentageToLetterGrade(
  percentage: number,
  useCustomScale = false,
): string {
  // Custom scale (as shown in image: A+ at 56%)
  if (useCustomScale) {
    if (percentage >= 90) return "A+";
    if (percentage >= 80) return "A";
    if (percentage >= 75) return "B+";
    if (percentage >= 70) return "B";
    if (percentage >= 65) return "C+";
    if (percentage >= 60) return "C";
    if (percentage >= 55) return "D+";
    if (percentage >= 50) return "D";
    if (percentage >= 45) return "D-";
    return "F";
  }

  // Standard scale
  if (percentage >= 97) return "A+";
  if (percentage >= 93) return "A";
  if (percentage >= 90) return "A-";
  if (percentage >= 87) return "B+";
  if (percentage >= 83) return "B";
  if (percentage >= 80) return "B-";
  if (percentage >= 77) return "C+";
  if (percentage >= 73) return "C";
  if (percentage >= 70) return "C-";
  if (percentage >= 67) return "D+";
  if (percentage >= 63) return "D";
  if (percentage >= 60) return "D-";
  return "F";
}

/**
 * Calculate percentage from marks
 * @param obtained - Marks obtained
 * @param total - Total marks
 * @returns Percentage (0-100)
 */
export function calculatePercentage(obtained: number, total: number): number {
  if (total === 0) return 0;
  return Math.round((obtained / total) * 100);
}

/**
 * Format percentage for display
 * @param percentage - Percentage value
 * @returns Formatted percentage string
 */
export function formatPercentage(percentage: number): string {
  return `${Math.round(percentage)}%`;
}
